import { z } from 'zod'
import { ColumnFiltersSchema, FilterMatch } from './schemas'

export const TableLayoutSchema = z.object({
  filters: ColumnFiltersSchema.default([]),
  sorts: z.array(z.object({ column_id: z.string(), descending: z.boolean() })).default([]),
  filter_match: z.nativeEnum(FilterMatch).default(FilterMatch.All),
  search: z.string().default(''),
  order: z.array(z.string()),
  hidden: z.array(z.string()),
  pinned: z.array(z.string()),
  widths: z.record(z.string(), z.number().positive().finite()),
  entry_width: z.number().positive().finite().nullable(),
  row_heights: z.record(z.string(), z.number().positive().finite()).default({}),
})
export type TableLayout = z.infer<typeof TableLayoutSchema>
export const defaultTableLayout: TableLayout = TableLayoutSchema.parse({ order: [], hidden: [], pinned: [], widths: {}, entry_width: null })

/** Ignore removed IDs and append new columns without disturbing the saved order. */
export function orderedColumns(ids: string[], layout: TableLayout): string[] {
  const current = new Set(ids)
  return [...new Set([...layout.order.filter((id) => current.has(id)), ...ids])]
}

export function visibleColumnOrder(ids: string[], layout: TableLayout): string[] {
  const visible = orderedColumns(ids, layout).filter((id) => !layout.hidden.includes(id))
  return [...visible.filter((id) => layout.pinned.includes(id)), ...visible.filter((id) => !layout.pinned.includes(id))]
}

export function moveColumn(ids: string[], layout: TableLayout, from: string, to: string): TableLayout {
  const order = orderedColumns(ids, layout)
  const index = order.indexOf(to)
  if (from === to || index < 0 || !order.includes(from)) return layout
  order.splice(order.indexOf(from), 1)
  order.splice(index, 0, from)
  return { ...layout, order }
}
